import { MarketplaceStoreEditionType } from '@atlassian/mpac-types/graphql-gateway-types';
export const FEATURE_COUNT_FOR_DISPLAY = 5;
export const DEFAULT_SELECTED_PLAN = MarketplaceStoreEditionType.Advanced;